import { render, staticRenderFns } from "./VerticalLayoutLargeThumbnail.vue?vue&type=template&id=aa11b886&scoped=true"
import script from "./VerticalLayoutLargeThumbnail.vue?vue&type=script&lang=js"
export * from "./VerticalLayoutLargeThumbnail.vue?vue&type=script&lang=js"
import style0 from "./VerticalLayoutLargeThumbnail.vue?vue&type=style&index=0&id=aa11b886&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa11b886",
  null
  
)

export default component.exports